export const getPrevSegmentationFrame = (segmentationEntries: [string, number][], currentPosition: string) => {
    const positionIndex = segmentationEntries.findIndex(([position]) => position === currentPosition);
    if (positionIndex === -1) {
        throw new Error(`Scrubber error: position ${currentPosition} not found in segmentation data`);
    }

    const nextSegment = segmentationEntries[Math.min(positionIndex - 1, 10)];
    if (!nextSegment) {
        throw new Error(`Scrubber error: next segment not found`);
    }

    const [, segmentFrame] = nextSegment;
    return segmentFrame;
};

export const getNextSegmentationFrame = (segmentationEntries: [string, number][], currentPosition: string) => {
    const positionIndex = segmentationEntries.findIndex(([position]) => position === currentPosition);
    if (positionIndex === -1) {
        throw new Error(`Scrubber error: position ${currentPosition} not found in segmentation data`);
    }

    const nextSegment = segmentationEntries[Math.max(positionIndex + 1, 0)];
    if (!nextSegment) {
        throw new Error(`Scrubber error: prev segment not found`);
    }

    const [, segmentFrame] = nextSegment;
    return segmentFrame;
};
